'use strict';

export default class GrpTransactionViewCtrl {
  constructor($stateParams, $state, LoaderSvc, GrpTxnSvc, GroupAuthSvc) {
    var that = this;
    this.ctxId = $stateParams.ctxId;
    this.groupId = $stateParams.groupId; // current group
    this.gtId = $stateParams.gtId;

    // authorization
    GroupAuthSvc.validatePermission(this.groupId, 'groupTransaction', 'R');

    if(!this.gtId) {
      return $state.go('group.view.groupTransaction.list');
    }
    //load groupTransaction
    function loadgroupTransaction() {
      LoaderSvc.start();
      var reqParams = {
        groupId: that.groupId,
        id: that.gtId
      };
      GrpTxnSvc.get(reqParams).$promise
        .then(function(groupTransaction) {
        // get linked financial trnsaction
        // set status
          that.groupTransaction = groupTransaction;
          var finTxn = groupTransaction.financialTransaction;
          if(!finTxn) {
            groupTransaction.status = 'Unpaid';
          } else if(finTxn.acceptedAt) {
            groupTransaction.status = 'Paid';
          } else if(finTxn.submittedAt) {
            groupTransaction.status = 'Pending - Payment Submitted';
          }

          LoaderSvc.stop();
        }).catch(function() {
          LoaderSvc.stopError('Error loading Group Transaction');
        });
    }
    loadgroupTransaction();
  }
}
